import MapContainerRefContext from "../website/components/MapContainerRefContext";
import MapButton from "./MapButton";
import { css } from "@emotion/react";
import { styleUtils, theme } from "@minted/minted-components";
import React, { ReactNode, useContext } from "react";

const styles = {
  button: css`
    display: none;
    position: absolute;
    top: ${styleUtils.rem(10)};
    left: ${styleUtils.rem(10)};

    ${theme.media.greaterThan(theme.breakpoints.medium)(`
      display: block;
    `)}
  `,
  frame: css`
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: auto;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  `,
  inner: {
    base: css`
      position: relative;
      height: ${styleUtils.rem(400)};
    `,
    expanded: css`
      ${theme.media.greaterThan(theme.breakpoints.medium)(`
        height: ${styleUtils.rem(600)};
      `)}
    `,
  },
};

export type MapContainerProps = {
  children: ReactNode;
  isExpanded: boolean;
  onExpandToggle: () => void;
};

const MapContainer = ({
  children,
  isExpanded,
  onExpandToggle,
}: MapContainerProps) => {
  const mapContainerRef = useContext(MapContainerRefContext);

  return (
    <div css={styles.frame} ref={mapContainerRef}>
      <div css={[styles.inner.base, isExpanded && styles.inner.expanded]}>
        {children}
        <div css={styles.button}>
          <MapButton
            onClick={onExpandToggle}
            text={isExpanded ? "Shrink Map" : "Expand Map"}
          />
        </div>
      </div>
    </div>
  );
};

export default MapContainer;
